import React, { useState, useEffect } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { SidebarNav } from "./SidebarNav";
import { TopBar } from "./TopBar";
import { CommandBar } from "@/components/command/CommandBar";
import { RightAiPanel } from "@/components/ai/RightAiPanel";
import { NotificationsPanel } from "./NotificationsPanel";
import api from "@/lib/api";

export const AppShell = () => {
  const { user, loading } = useAuth();
  const navigate = useNavigate();
  const [collapsed, setCollapsed] = useState(false);
  const [cmdOpen, setCmdOpen] = useState(false);
  const [aiOpen, setAiOpen] = useState(false);
  const [notifOpen, setNotifOpen] = useState(false);
  const [aiSeed, setAiSeed] = useState(null);
  const [unread, setUnread] = useState(0);

  useEffect(() => {
    if (!loading && !user) navigate("/login");
    if (!loading && user && user.onboarded === false) navigate("/onboarding");
  }, [loading, user, navigate]);

  useEffect(() => {
    if (loading || !user || user.onboarded === false || user.is_super_admin) return;
    let cancelled = false;
    api.get("/billing/subscription").then(({ data }) => {
      if (cancelled) return;
      if (!data.is_managed_externally && ["pending_payment", "trial_expired"].includes(data.status)) {
        navigate("/select-plan", { replace: true });
      }
    }).catch(() => {});
    return () => { cancelled = true; };
  }, [loading, user, navigate]);

  useEffect(() => { api.get("/notifications").then(({ data }) => setUnread(data.unread || 0)).catch(() => {}); }, []);

  const askAi = (q) => { setAiSeed(q + " #" + Date.now()); setAiOpen(true); };

  if (loading) return <div className="h-screen flex items-center justify-center text-slate-400">Loading Aurelo…</div>;
  if (!user) return null;

  return (
    <div className="flex min-h-screen bg-[#F1F5F9]">
      <SidebarNav collapsed={collapsed} setCollapsed={setCollapsed} />
      <div className="flex-1 min-w-0 flex flex-col">
        <TopBar onOpenCommand={() => setCmdOpen(true)} onOpenAi={() => { setAiSeed(null); setAiOpen(true); }} onOpenNotifications={() => setNotifOpen(true)} unread={unread} />
        <main className="flex-1 p-4 md:p-6 max-w-[1600px] w-full mx-auto">
          <Outlet context={{ askAi }} />
        </main>
      </div>
      <CommandBar open={cmdOpen} setOpen={setCmdOpen} onAskAi={askAi} />
      <RightAiPanel open={aiOpen} setOpen={setAiOpen} seedMessage={aiSeed} />
      <NotificationsPanel open={notifOpen} setOpen={setNotifOpen} onChange={setUnread} />
    </div>
  );
};
